import {
  BRAND_SELECT,
  BRANDS_FETCH,
  FETCH_RESET,
  GAME_RESET,
  GAME_RUN,
  GAMES_FETCH,
  PROVIDER_SELECT,
  PROVIDERS_FETCH,
  SEARCH_QUERY_CLEAR,
  SEARCH_QUERY_SET,
  TAG_FAVORITE_SELECT,
  TAG_SELECT,
  TAGS_FETCH,
  UPDATE_FAVORITE_GAME,
} from "../constants";

export const fetchGames = (hallId = 0) => ({
  type: GAMES_FETCH,
  payload: { hallId },
});

export const fetchProviders = (hallId = 0) => ({
  type: PROVIDERS_FETCH,
  payload: { hallId },
});

export const selectProvider = (id) => ({
  type: PROVIDER_SELECT,
  payload: id,
});

export const fetchBrands = (bankGroupStringId = 0) => ({
  type: BRANDS_FETCH,
  payload: { bankGroupStringId },
});

export const selectBrand = (id) => ({
  type: BRAND_SELECT,
  payload: id,
});

export const fetchTags = (bankGroupStringId = 0) => ({
  type: TAGS_FETCH,
  payload: { bankGroupStringId },
});

export const selectTag = (id) => ({
  type: TAG_SELECT,
  payload: id,
});

export const selectFavoriteFilter = (isFavorite) => ({
  type: TAG_FAVORITE_SELECT,
  payload: isFavorite,
});

export const updateFavoriteItem = (gameId, isFavorite) => ({
  type: UPDATE_FAVORITE_GAME,
  payload: { gameId, isFavorite },
});

export const setSearchQuery = (searchQuery) => ({
  type: SEARCH_QUERY_SET,
  payload: searchQuery,
});

export const clearSearchQuery = () => ({
  type: SEARCH_QUERY_CLEAR,
  payload: "",
});

/**
 * @name runGame
 * @param params
 * @returns {{payload: {demo: boolean, game: string, place?: RunType}, type: string}}
 */
export const runGame = (params) => ({
  type: GAME_RUN,
  payload: params,
});

export const resetGame = () => ({
  type: GAME_RESET,
  payload: {},
});

export const resetFetch = () => ({
  type: FETCH_RESET,
  payload: {},
});
